<div class="rightComp action-plan-page">
  <div class="col-12 action-item-container">
    <div class="action-item-section-header mb-3" [ngClass]="isArabic ? 'flex-row-reverse': 'flex-row'">
      <div>
        <div *ngIf="!isArabic">
          <span class="header-font">Assessment Name: </span>
          <span class="font-radikal-light">{{ finesDetail[0]?.mde_AssessmentEntity?.name }}</span>
        </div>
        <div *ngIf="isArabic"
          style="display: flex; justify-content: flex-start; gap: 8px; direction: rtl; text-align: right;flex-direction: row-reverse;">
          <span class="font-radikal-light">{{ finesDetail[0]?.mde_AssessmentEntity?.name }}</span>
          <span class="header-font">:اسم التقييم</span>
        </div>

        <div *ngIf="!isArabic">
          <span class="header-font">Inspection: </span>
          <span class="font-radikal-light">{{ finesDetail[0]?.mde_InspectionPlan?.mde_name }}</span>
        </div>
        <div *ngIf="isArabic"
          style="display: flex; justify-content: flex-start; gap: 8px; direction: rtl; text-align: right;flex-direction: row-reverse;">
          <span class="font-radikal-light">{{ finesDetail[0]?.mde_InspectionPlan?.mde_name }}</span>
          <span class="header-font">:التفتيش</span>
        </div>
      </div>
    </div>

    <table class="table table-striped customTable" *ngFor="let fine of calculatedFinesDetail; let i = index">
      <tbody>
        <tr>
          <td>
            <div class="fine-card">
              <div class="action-item-header" [ngClass]="isArabic ? 'pull-right' : 'pull-left'">
                <div class="index-circle"><span><b>{{ i+1 }}</b></span></div>
                <div class="action-item-title">
                  <span *ngIf="!isArabic">Action Item:
                    <span class="font-radikal-light">{{ fine?.mde_actionitem?.mde_name }}</span>
                  </span>
                  <span *ngIf="isArabic">عنصر الإجراء:
                    <span class="font-radikal-light">{{ fine?.mde_actionitem?.mde_name }}</span>
                  </span>
                </div>
              </div>

              <div class="mt-2" [ngClass]="isArabic ? 'pull-right' : 'pull-left'">
                <ng-container *ngIf="!isArabic">
                  Violation:
                  <span class="font-radikal-light">{{ fine?.mde_Violation?.mde_name }}</span>
                </ng-container>
                <ng-container *ngIf="isArabic">
                  <b>المخالفة:</b>
                  <span class="font-radikal-light">{{ fine?.mde_Violation?.mde_name }}</span>
                </ng-container>
              </div>

              <table class="table mb-0 fine-table">
                <tbody>
                  <tr>
                    <td>
                      <ng-container *ngIf="!isArabic">Warning 1 Fine Amount:</ng-container>
                      <ng-container *ngIf="isArabic">قيمة غرامة الإنذار الأول:</ng-container>
                      <input class="form-control" type="text" [value]="fine?.mde_Violation?.mde_1stwarningfines"
                        readonly [attr.disabled]="null" />
                    </td>
                    <td>
                      <ng-container *ngIf="!isArabic">Warning 2 Fine Amount:</ng-container>
                      <ng-container *ngIf="isArabic">قيمة غرامة الإنذار الثاني</ng-container>
                      <input class="form-control" type="text"
                        [value]="fine?.mde_Violation?.mde_2ndwarningremediationtimeframefines" readonly
                        [attr.disabled]="fine?.mde_name === 'Warning1' ? true : null" />
                    </td>
                    <td>
                      <ng-container *ngIf="!isArabic">Warning 3 Fine Amount:</ng-container>
                      <ng-container *ngIf="isArabic">قيمة غرامة الإنذار :</ng-container>
                      <input class="form-control" type="text"
                        [value]="fine?.mde_Violation?.mde_3rdwarningandsuspensionperiodfines" readonly
                        [attr.disabled]="fine?.mde_name === 'Warning1' || fine?.mde_name === 'Warning2' ? true : null" />
                    </td>
                  </tr>
                  <tr>
                    <td>
                      <ng-container *ngIf="!isArabic">Waived Off Fine Amount:</ng-container>
                      <ng-container *ngIf="isArabic">قيمة الغرامة المعفاة:</ng-container>
                      <input class="form-control" type="text" [value]="fine.cumulativeWaived" readonly />
                    </td>
                    <td>
                      <ng-container *ngIf="!isArabic">Total Outstanding Fine Amount:</ng-container>
                      <ng-container *ngIf="isArabic">إجمالي قيمة الغرامات المستحقة:</ng-container>
                      <input class="form-control" type="text" [value]="fine.cumulativeTotal" readonly />
                    </td>
                    <td>
                      <ng-container *ngIf="!isArabic">Fine Status:</ng-container>
                      <ng-container *ngIf="isArabic">حالة الغرامة:</ng-container>
                      <input class="form-control" type="text" [value]=" 
                          fine.mde_enforcementstatus === 755020000 ? 'Active' : 
                          fine.mde_enforcementstatus === 755020001 ? 'Closed' : 
                          fine.mde_enforcementstatus === 755020002 ? 'Cancelled' : 
                          fine.mde_enforcementstatus === 755020003 ? 'Draft' : 
                          fine.mde_enforcementstatus === 755020004 ? 'Paid' : 
                          fine.mde_enforcementstatus === 755020005 ? 'Partially Paid' : 
                          fine.mde_enforcementstatus === 755020006 ? 'Void' : 
                          '' 
                        " readonly />
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</div>